import React, { useState } from 'react';

/**
 * TagsInput
 * Hand-rolled badge/tag input: Enter or comma commits the current text
 * as a new tag (trimmed, lowercased, de-duplicated against existing
 * tags). Each tag renders as a badge with a remove (×) button.
 */
const TagsInput = ({ value = [], onChange, placeholder = '' }) => {
  const [inputValue, setInputValue] = useState('');

  const commitTag = (raw) => {
    const tag = raw.trim().toLowerCase();
    if (!tag) return;
    if (value.includes(tag)) return;
    onChange([...value, tag]);
  };

  const handleChange = (e) => {
    const next = e.target.value;
    if (next.endsWith(',')) {
      commitTag(next.slice(0, -1));
      setInputValue('');
      return;
    }
    setInputValue(next);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      commitTag(inputValue);
      setInputValue('');
    }
  };

  const handleRemove = (tag) => {
    onChange(value.filter((t) => t !== tag));
  };

  return (
    <div className="tags-input">
      {value.map((tag) => (
        <span key={tag} className="tag-badge">
          {tag}
          <button
            type="button"
            onClick={() => handleRemove(tag)}
            className="tag-remove"
            aria-label={`Remove ${tag}`}
          >
            ×
          </button>
        </span>
      ))}
      <input
        type="text"
        value={inputValue}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        className="form-input"
      />
    </div>
  );
};

export default TagsInput;
